import React, { useState, useEffect } from 'react'
import {
  FaFacebook, FaInstagram, FaYoutube,
  FaPhone, FaEnvelope, FaBuilding, FaUserCircle,
  FaSignInAlt, FaHeadset, FaUserTie, FaChevronRight, FaMapMarkerAlt, FaTimes
} from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import { useLanguage } from '../contexts/LanguageContext'
import logo from '../components/Assets/SHIVPRATAP LOGO.png'
import engLogo from '../components/Assets/eng logo.jpeg'

const Footer = () => {
  const navigate = useNavigate()
  const { language } = useLanguage()
  const [selectedLanguage, setSelectedLanguage] = useState('मराठी')

  // Sync selectedLanguage with context language
  useEffect(() => {
    setSelectedLanguage(language === 'en' ? 'English' : 'मराठी')
  }, [language])

  // Sync selectedLanguage with context language
  const translations = {
    en: {
      bankName: 'Shivpratap Multistate Nagari Co-operative Credit Society',
      tagline: 'Transact financial transactions through mobile banking now without visiting an institution. More work in less time. Shiv Pratap Multistate Mobile Banking is providing the facility to make customer transactions more dynamic and cashless. Through this, the customer can make payments, pay bills, check account balance, etc. from his mobile phone.',
      followUs: 'Follow Us',
      bankingOnTheGo: 'Banking on the go',
      quickLinks: 'Quick Links',
      ourServices: 'Contact & Inquiry',
      contactInformation: 'Contact Information',
      businessHours: 'Business Hours',
      loginRegister: 'Login / Register',
      privacyPolicy: {
        title: 'Privacy Policy',
        points: [
          'Shivpratap Multistate Nagari Co-op. Credit Society respects the privacy of all its members.',
          'We collect basic personal details like name, address, and contact number.',
          'We may also collect ID proof and financial information when required.',
          'The information is collected only for providing our services.',
          'We use the data for account opening and loan processing.',
          'Your information is stored safely in secure systems.',
          'Only authorized staff can access your information.',
          'We do not sell or share your personal data.',
          'Information may be shared only if required by law.',
          'Members can contact us for any privacy-related questions.'
        ]
      },
      termsConditions: {
        title: 'Terms & Conditions',
        points: [
          'By using services of Shivpratap Multistate Nagari Co-op. Credit Society, you agree to our rules.',
          'All members must provide correct and true information.',
          'Loans and deposits are subject to approval by the Society.',
          'Members must follow all Society policies.',
          'Interest rates and charges may change as per rules.',
          'The Society can update terms anytime if needed.',
          'Members should read all documents carefully before signing.',
          'Delayed payments may attract penalties.',
          'Services are provided as per applicable laws.',
          'Any dispute will be handled as per legal procedures.'
        ]
      },
      disclaimer: {
        title: 'Disclaimer',
        points: [
          'Shivpratap Multistate Nagari Co-op. Credit Society provides information for general guidance.',
          'We try to keep all information correct and updated.',
          'However, we do not guarantee complete accuracy at all times.',
          'The Society is not responsible for any technical errors.',
          'Members should verify details before making decisions.',
          'Financial decisions are taken at the member’s own risk.',
          'The Society is not liable for losses due to misuse of information.',
          'Website services may be temporarily unavailable at times.',
          'External links, if any, are not under our control.',
          'By using our services, you agree to this disclaimer.'
        ]
      },
      allRightsReserved: 'All rights reserved.',

      regulatoryInfo: '',
      links: {
        home: 'Home',
        aboutUs: 'About Us',
        services: 'Services',
        schemes: 'Schemes',
        contactUs: 'Contact Us',
        branch: 'Branch',
        gallery: 'Gallery',
        media: 'Media',
        annualReport: 'Annual Report',
        career: 'Career',
        organization: 'Organization',
        director: 'Director',
        account: 'Account',
        plan: 'Plan',
        loan: 'Loan'
      },
      servicesList: {
        savingsAccount: 'Savings Account',
        loans: 'Loans',
        currentAccount: 'Current Account'
      },
      contact: {
        phone: '+91 9582837032',
        email: 'customercare@shivpratapmultistate.in ',
        address: 'Shivpratap Nagari Co-op. Credit Society Ltd. Vita (Multistate) Shiv Pratap Gold Tower, Vita h Khanapur, Dist. Sangli (Maharashtra)'

      },
      hours: {
        monFri: 'Mon - Sat',
        saturday: 'Saturday:',
        sunday: 'Sunday & Public Holidays:',
        secondFourthSat: '2nd & 4th Saturday:',
        monFriTime: '10:00 AM - 6:00 PM',
        saturdayTime: '9:00 AM - 1:00 PM',
        closed: 'Closed'
      }
    },
    mr: {
      bankName: 'शिवप्रताप मल्टीस्टेट नागरी को-ऑप. क्रेडिट सोसायटी',
      tagline: 'आर्थिक व्यवहारांसाठी आता संस्थेमध्ये न जाता मोबाईल बँकिंगद्वारे व्यवहार करा. कमी वेळेत अधिक कामे. ग्राहकांचे व्यवहार अधिक गतिमान व कॅशलेस व्हावे यासाठी शिवप्रताप मल्टिस्टेट मोबाईल बँकिंग हि सुविधा देत आहे. याद्वारे ग्राहक त्याच्या मोबाईल फोन वरून पैसे देणे-घेणे, बिल भरणे, खात्यातील शिल्लक तपासणे इ. कामे करू शकतो.',
      followUs: 'फॉलो करा',
      bankingOnTheGo: 'मोबाइल बँकिंग',
      quickLinks: 'त्वरित लिंक',
      ourServices: 'संपर्क व चौकशी',
      contactInformation: 'संपर्क माहिती',
      businessHours: 'कार्यालय वेळ',
      loginRegister: 'लॉगिन / नोंदणी',
      privacyPolicy: {
        title: 'गोपनीयता धोरण',
        points: [
          'Shivpratap Multistate Nagari Co-op. Credit Society respects the privacy of all its members.',
          'We collect basic personal details like name, address, and contact number.',
          'We may also collect ID proof and financial information when required.',
          'The information is collected only for providing our services.',
          'We use the data for account opening and loan processing.',
          'Your information is stored safely in secure systems.',
          'Only authorized staff can access your information.',
          'We do not sell or share your personal data.',
          'Information may be shared only if required by law.',
          'Members can contact us for any privacy-related questions.'
        ]
      },
      termsConditions: {
        title: 'अटी व शर्ती',
        points: [
          'By using services of Shivpratap Multistate Nagari Co-op. Credit Society, you agree to our rules.',
          'All members must provide correct and true information.',
          'Loans and deposits are subject to approval by the Society.',
          'Members must follow all Society policies.',
          'Interest rates and charges may change as per rules.',
          'The Society can update terms anytime if needed.',
          'Members should read all documents carefully before signing.',
          'Delayed payments may attract penalties.',
          'Services are provided as per applicable laws.',
          'Any dispute will be handled as per legal procedures.'
        ]
      },
      disclaimer: {
        title: 'अस्वीकरण',
        points: [
          'Shivpratap Multistate Nagari Co-op. Credit Society provides information for general guidance.',
          'We try to keep all information correct and updated.',
          'However, we do not guarantee complete accuracy at all times.',
          'The Society is not responsible for any technical errors.',
          'Members should verify details before making decisions.',
          'Financial decisions are taken at the member’s own risk.',
          'The Society is not liable for losses due to misuse of information.',
          'Website services may be temporarily unavailable at times.',
          'External links, if any, are not under our control.',
          'By using our services, you agree to this disclaimer.'
        ]
      },
      allRightsReserved: 'सर्व हक्क राखीव.',

      regulatoryInfo: '',
      links: {
        home: 'होम',
        aboutUs: 'आमच्याबद्दल',
        services: 'सेवा',
        schemes: 'योजना',
        contactUs: 'आमच्याशी संपर्क साधा',
        branch: 'शाखा',
        gallery: 'गॅलरी',
        media: 'मीडिया',
        annualReport: 'वार्षिक अहवाल',
        career: 'करिअर',
        organization: 'संस्थेविषयी',
        director: 'संचालक मंडळ',
        account: 'खाते',
        plan: 'योजना',
        loan: 'कर्ज'
      },
      servicesList: {
        savingsAccount: 'बचत खाते',
        loans: 'कर्ज',
        currentAccount: 'चालू खाते'
      },
      contact: {
        phone: '+91 9582837032',
        email: 'customercare@shivpratapmultistate.in',
        address: 'शिवप्रताप मल्टीस्टेट नागरी को-ऑप. क्रेडिट सोसायटी लि. विटा. '

      },
      hours: {
        monFri: 'सोम - शनिवार:',
        saturday: 'शनिवार:',
        sunday: 'रविवार व सार्वजनिक सुट्टी:',
        secondFourthSat: '२ रा ४ था शनिवार:',
        monFriTime: 'सकाळी १०.०० ते सायंकाळी ६.००',
        // saturdayTime: 'सकाळी ९:०० - दुपारी ६:००',
        closed: 'बंद'
      }
    }
  }

  // Get current language content
  const currentLang = selectedLanguage === 'English' ? 'en' : 'mr'
  const currentContent = translations[currentLang]

  // Social media links with actual URLs
  const socialLinks = [
    {
      icon: FaFacebook,
      url: 'https://www.facebook.com/share/1HwBD72Dr8/',
      color: 'hover:bg-blue-600',
      name: 'Facebook'
    },
    {
      icon: FaInstagram,
      url: 'https://www.instagram.com/shivpratapmultistate?igsh=MWxlb2szNDNnYzZ6cQ==',
      color: 'hover:bg-pink-600',
      name: 'Instagram'
    },
    {
      icon: FaYoutube,
      url: 'https://youtube.com/@shivpratapmultistatevita?si=ynsKf3N1Ic3DRXX-',
      color: 'hover:bg-red-600',
      name: 'YouTube'
    }
  ]

  // Quick Links with actual paths
  const quickLinks = [
    { name: currentContent.links.organization, path: '/' },
    { name: currentContent.links.director, path: '/managing-director' },
    { name: currentContent.links.account, path: '/savings-account' },
    { name: currentContent.links.plan, path: '/plan' },
    { name: currentContent.links.loan, path: '/loan' },
    { name: currentContent.links.branch, path: '/branch' },
    { name: currentContent.links.gallery, path: '/gallery' },
    { name: currentContent.links.media, path: '/media' },
    { name: currentContent.links.annualReport, path: '/annual-report' },
    { name: currentContent.links.career, path: '/career' }
  ]

  // Services links
  const services = [
    { name: currentContent.links.contactUs, path: '/contact', icon: FaHeadset },
    { name: currentContent.links.career, path: '/career', icon: FaUserTie }
  ]

  // Contact details
  const contactInfo = [
    { icon: FaPhone, text: currentContent.contact.phone, type: 'phone' },
    { icon: FaEnvelope, text: currentContent.contact.email, type: 'email' },
    { icon: FaBuilding, text: currentContent.contact.address, type: 'address' }
  ]

  const handleLoginClick = () => {
    navigate('/login')
  }

  const handleSocialClick = (url) => {
    window.open(url, '_blank', 'noopener noreferrer')
  }

  const handleLinkClick = (path) => {
    // Map paths to navbar dropdown indices
    const dropdownMap = {
      '/managing-director': 1,
      '/savings-account': 2,
      '/plan': 3,
      '/loan': 4,
      '/branch': 5
    }

    if (dropdownMap[path]) {
      // If it's a dropdown trigger, scroll to top and open dropdown without navigating
      window.scrollTo({ top: 0, behavior: 'smooth' })
      const event = new CustomEvent('open-navbar-dropdown', {
        detail: { index: dropdownMap[path] }
      })
      window.dispatchEvent(event)
    } else {
      // Normal navigation
      navigate(path)
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }

  const handleContactClick = (type, value) => {
    switch (type) {
      case 'phone':
        window.location.href = `tel:${value}`
        break
      case 'email':
        window.location.href = `mailto:${value}`
        break
      default:
        // For address, could open maps
        const mapsUrl = `https://maps.google.com/?q=${encodeURIComponent(value)}`
        window.open(mapsUrl, '_blank', 'noopener noreferrer')
    }
  }

  return (
    <footer className="relative bg-[#0f172a] text-gray-300 pt-16 pb-8 overflow-hidden font-sans">
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-purple-500 via-pink-500 to-red-500 z-20"></div>
      <div className="absolute -top-[20%] -right-[10%] w-[500px] h-[500px] bg-purple-600/10 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-[10%] -left-[10%] w-[400px] h-[400px] bg-blue-600/10 rounded-full blur-3xl pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">

        {/* Top Section: Login & Logo */}
        <div className="flex flex-col md:flex-row justify-between items-center mb-12 border-b border-gray-800 pb-8">
          <div className="flex items-center gap-4 mb-6 md:mb-0">
            <div className="relative group">
              <div className="absolute -inset-0.5 bg-gradient-to-r from-purple-600 to-pink-600 rounded-2xl blur opacity-30 group-hover:opacity-75 transition duration-500"></div>
              <img src={selectedLanguage === 'English' ? engLogo : logo} alt="Shivpratap Multistate" className="relative w-16 h-16 rounded-xl object-contain bg-white/90 p-1" />
            </div>
            <div>
              <h3 className="text-xl font-bold text-white tracking-tight">{currentContent.bankName}</h3>
              <p className="text-xs text-gray-400 max-w-md hidden sm:block">{currentContent.tagline && currentContent.tagline.substring(0, 80)}...</p>
            </div>
          </div>

          <button
            onClick={handleLoginClick}
            className="group relative px-6 py-2.5 bg-gray-800 rounded-full overflow-hidden shadow-lg hover:shadow-purple-500/25 transition-all duration-300"
          >
            <div className="absolute inset-0 w-full h-full bg-gradient-to-r from-purple-600 to-pink-600 opacity-80 group-hover:opacity-100 transition-opacity"></div>
            <div className="relative flex items-center gap-2 font-bold text-white">
              <FaUserCircle className="text-lg" />
              <span>{currentContent.loginRegister}</span>
              <FaSignInAlt className="group-hover:translate-x-1 transition-transform" />
            </div>
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">

          {/* Column 1: About & Social */}
          <div className="space-y-6 text-center md:text-left">
            <div>
              <h4 className="text-sm font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400 uppercase tracking-widest mb-4">
                {currentContent.followUs}
              </h4>
              <p className="text-sm text-gray-400 mb-4 leading-relaxed">
                {currentContent.tagline}
              </p>
              <div className="flex justify-center md:justify-start gap-3">
                {socialLinks.map((social, index) => (
                  <button
                    key={index}
                    onClick={() => handleSocialClick(social.url)}
                    className={`w-10 h-10 rounded-full bg-gray-800/50 flex items-center justify-center transition-all duration-300 hover:scale-110 hover:-translate-y-1 hover:shadow-lg hover:shadow-${social.name === 'Facebook' ? 'blue' : social.name === 'Instagram' ? 'pink' : 'red'}-500/30 group border border-gray-700/50`}
                  >
                    <social.icon className={`text-lg text-gray-400 group-hover:text-white transition-colors`} />
                  </button>
                ))}
              </div>
            </div>

            {/* App Badges */}
            <div className="pt-4 border-t border-gray-800/50">
              <h5 className="text-xs font-semibold text-gray-500 mb-3 uppercase">{currentContent.bankingOnTheGo}</h5>
              <div className="flex justify-center md:justify-start gap-3 opacity-80 hover:opacity-100 transition-opacity">
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                  alt="Play Store"
                  className="h-8 cursor-pointer hover:scale-105 transition-transform"
                  onClick={() => window.open('https://play.google.com/store/apps/details?id=com.netwin.mobilebanking.shivp', '_blank')}
                />
                <img
                  src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                  alt="App Store"
                  className="h-8 cursor-pointer hover:scale-105 transition-transform"
                  onClick={() => window.open('https://play.google.com/store/apps/details?id=com.netwin.mobilebanking.shivp', '_blank')}
                />
              </div>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div>
            <h4 className="text-sm font-bold text-white uppercase tracking-widest mb-6 border-b border-gray-800 pb-2 inline-block">
              {currentContent.quickLinks}
            </h4>
            <ul className="grid grid-cols-2 gap-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <button
                    onClick={() => handleLinkClick(link.path)}
                    className="flex items-center gap-2 text-sm text-gray-400 hover:text-purple-400 transition-colors group w-full text-left bg-gray-800/20 p-2 rounded-lg hover:bg-gray-800/50"
                  >
                    <span className="w-1.5 h-1.5 rounded-full bg-gray-600 group-hover:bg-purple-500 transition-colors flex-shrink-0"></span>
                    <span className="truncate group-hover:translate-x-1 transition-transform duration-300">{link.name}</span>
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Services */}
          <div>
            <h4 className="text-sm font-bold text-white uppercase tracking-widest mb-6 border-b border-gray-800 pb-2 inline-block">
              {currentContent.ourServices}
            </h4>
            <div className="space-y-3">
              {services.map((service, index) => (
                <button
                  key={index}
                  onClick={() => handleLinkClick(service.path)}
                  className="flex items-center gap-3 p-3 w-full bg-gray-800/30 rounded-xl border border-gray-700/30 hover:bg-gray-800 hover:border-purple-500/30 transition-all duration-300 group text-left shadow-sm hover:shadow-purple-500/10"
                >
                  <div className="w-10 h-10 rounded-lg bg-gray-700/50 flex items-center justify-center text-purple-400 group-hover:scale-110 transition-transform flex-shrink-0">
                    <service.icon className="text-lg" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <span className="block text-sm font-semibold text-gray-200 group-hover:text-white transition-colors truncate">{service.name}</span>
                    <span className="text-[10px] text-gray-500 group-hover:text-purple-400 transition-colors">Tap to view</span>
                  </div>
                  <FaChevronRight className="ml-auto text-gray-600 group-hover:text-purple-400 transition-colors text-xs flex-shrink-0" />
                </button>
              ))}
            </div>
          </div>

          {/* Column 4: Contact Info */}
          <div className="space-y-8">
            <div>
              <h4 className="text-sm font-bold text-white uppercase tracking-widest mb-6 border-b border-gray-800 pb-2 inline-block">
                {currentContent.contactInformation}
              </h4>
              <ul className="space-y-3">
                {contactInfo.map((contact, index) => (
                  <li key={index}>
                    <button
                      onClick={() => handleContactClick(contact.type, contact.text)}
                      className="flex items-start gap-3 text-left group w-full hover:bg-gray-800/30 p-2 rounded-lg transition-colors"
                    >
                      <div className="mt-0.5 w-8 h-8 rounded-full bg-purple-500/10 flex items-center justify-center text-purple-400 flex-shrink-0 group-hover:bg-purple-500 group-hover:text-white transition-all">
                        <contact.icon className="text-xs" />
                      </div>
                      <div className="min-w-0">
                        <p className="text-[10px] font-semibold text-gray-500 uppercase mb-0.5 tracking-wider">{contact.type}</p>
                        <p className="text-sm text-gray-300 group-hover:text-white transition-colors break-words leading-snug">{contact.text}</p>
                      </div>
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Business Hours Mini-Card */}
            <div className="bg-gradient-to-br from-gray-800/50 to-gray-900/50 p-4 rounded-xl border border-gray-700/30 backdrop-blur-sm shadow-inner">
              <h5 className="text-xs font-bold text-gray-400 uppercase mb-3 flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></div>
                {currentContent.businessHours}
              </h5>
              <div className="space-y-2 text-xs text-gray-300">
                <div className="flex justify-between border-b border-gray-700/50 pb-1.5">
                  <span>{currentContent.hours.monFri}</span>
                  <span className="font-mono text-purple-300">{currentContent.hours.monFriTime}</span>
                </div>
                <div className="flex justify-between border-b border-gray-700/50 pb-1.5">
                  <span>{currentContent.hours.sunday}</span>
                  <span className="text-red-400 font-medium bg-red-400/10 px-1.5 rounded text-[10px] uppercase">{currentContent.hours.closed}</span>
                </div>
                <div className="flex justify-between pt-0.5">
                  <span>{currentContent.hours.secondFourthSat}</span>
                  <span className="text-red-400 font-medium bg-red-400/10 px-1.5 rounded text-[10px] uppercase">{currentContent.hours.closed}</span>
                </div>
              </div>
            </div>
          </div>

        </div>

        {/* Footer Bottom */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6 text-xs text-gray-500">
            <p className="text-center md:text-left">
              &copy; {new Date().getFullYear()} <span className="text-gray-300">{currentContent.bankName}</span>. {currentContent.allRightsReserved}
            </p>

            <div className="flex gap-6">
              {[
                { label: currentContent.privacyPolicy.title, path: '/privacy-policy' },
                { label: currentContent.termsConditions.title, path: '/terms-conditions' },
                { label: currentContent.disclaimer.title, path: '/disclaimer' }
              ].map((item, idx) => (
                <button
                  key={idx}
                  onClick={() => {
                    navigate(item.path);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                  className="hover:text-purple-400 transition-colors relative group"
                >
                  {item.label}
                  <span className="absolute bottom-0 left-0 w-0 h-px bg-purple-400 transition-all duration-300 group-hover:w-full"></span>
                </button>
              ))}
            </div>
          </div>

          <div className="mt-6 text-[10px] text-gray-600 text-center max-w-3xl mx-auto leading-relaxed">
            {currentContent.regulatoryInfo}
          </div>
        </div>
      </div>



      <style jsx>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 6px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: #111827;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #374151;
          border-radius: 3px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #4b5563;
        }
      `}</style>
    </footer>
  )
}

export default Footer